<body class="h-auto text-white bg-green-950">
  <header class="p-3 md:p-6">
    <nav
      class="bg-green-700 w-[-webkit-fill-available] rounded-xl shadow-lg border border-green-400"
    >
      <div class="px-4">
        <div class="flex justify-between h-16 items-center">
          <!-- Logo -->
          <a href="/" class="flex-shrink-0 text-white text-2xl font-bold">
            corpers.ng
          </a>

          <!-- Desktop Menu -->
          <div class="hidden md:flex space-x-6 text-white font-medium">
            <a href="/about" class="hover:text-yellow-300 transition">About</a>
            <a href="#services" class="hover:text-yellow-300 transition"
              >Services</a
            >
            <a href="#contact" class="hover:text-yellow-300 transition"
              >Contact</a
            >
          </div>

          <!-- Desktop Button -->
          <div class="hidden md:block">
            <a
              href="/signup"
              class="bg-white px-4 py-2 rounded hover:bg-yellow-300 text-black transition-all font-semibold"
            >
              Sign up
            </a>
          </div>
        </div>
      </div>
    </nav>
  </header>

  <section class="mt-2 md:mt-10 px-7 md:px-16" id="about">
    <h2 class="pt-4 text-4xl">About us, corpers.ng</h2>
    <p class="pt-4">
      corpers.ng is a platform dedicated to enhancing the experience of National
      Youth Service Corps (NYSC) members in Nigeria. Our mission is to provide
      essential services, resources, and support to help corps members thrive
      during their service year.
    </p>

    <p class="py-4">
      We understand the challenges faced by NYSC members, from finding
      accommodation and transportation to accessing job opportunities and
      community engagement. Our platform connects corps members with various
      services tailored to their needs, ensuring a smooth and enriching NYSC
      experience.
    </p>
  </section>

  <section class="mt-2 md:mt-10 px-7 md:px-16" id="terms">
    <h2 class="pt-4 text-4xl">Terms of Service for corpers.ng</h2>
    <h3 class="py-4 text-xl">Effective Date: June 4, 2025</h3>

    <p>
      Welcome to corpers.ng ("we," "our," or "us"). These Terms of Service
      ("Terms") govern your access to and use of our website, mobile
      application, and any related services (collectively, the "Services"). By
      accessing or using our Services, you agree to be bound by these Terms and
      our Privacy Policy. If you do not agree to these Terms, you may not use
      our Services.
    </p>

    <p>Please read these Terms carefully before using our Services.</p>

    <h3 class="pt-4 text-2xl">1. Acceptance of Terms</h3>
    <p>
      By accessing or using our Services, you affirm that you are at least 18
      years old and capable of entering into a binding contract, or that you
      have obtained parental or guardian consent if you are a minor and such
      consent is required by applicable law. You also agree that you have read,
      understood, and accept these Terms, as well as our Privacy Policy, which
      is incorporated by reference into these Terms.
    </p>
    <h3 class="pt-4 text-2xl">2. Changes to Terms</h3>
    <p>
      We may update these Terms from time to time to reflect changes in our
      Services, legal requirements, or best practices. We will notify you of any
      material changes by posting the updated Terms on our website or through
      other reasonable means. Your continued use of the Services after the
      effective date of the revised Terms constitutes your acceptance of the
      changes.
    </p>
    <h3 class="pt-4 text-2xl">3. Our Services</h3>
    <p>
      We provide a platform that connects National Youth Service Corps (NYSC)
      members with various services, including but not limited to accommodation,
      transportation, job opportunities, and community engagement. Our Services
      are designed to facilitate a smooth and enriching NYSC experience for
      users in Nigeria. We reserve the right to modify, suspend, or discontinue
      any aspect of our Services at any time without notice or liability. We may
      also impose limits on certain features or restrict your access to parts or
      all of our Services without notice or liability. We do not guarantee that
      our Services will be available at all times or that they will be free from
      errors or interruptions. We may also remove any content from our Services
      at our sole discretion, without notice or liability. You acknowledge that
      we are not responsible for the availability of third-party services or
      content that may be linked to or from our Services. We do not endorse,
      guarantee, or assume responsibility for any third-party services or
      content, and you agree that we are not liable for any loss or damage
      arising from your use of such third-party services or content.
    </p>
    <h3 class="pt-4 text-2xl">4. User Accounts</h3>
    <ul class="list-disc ps-5">
      <li>
        <strong>Registration:</strong> To access certain features of our
        Services, you may need to register for an account. You agree to provide
        accurate, complete, and current information during the registration
        process and to update such information to keep it accurate, complete,
        and current.
      </li>
      <li>
        <strong>Account Security:</strong> You are responsible for maintaining
        the confidentiality of your account login credentials and for all
        activities that occur under your account. You agree to notify us
        immediately of any unauthorized use of your account or any other breach
        of security. We will not be liable for any loss or damage arising from
        your failure to comply with this security obligation.
      </li>
      <li>
        <strong>Account Termination:</strong> We reserve the right to suspend or
        terminate your account at our sole discretion, without notice or
        liability, for any reason, including if you violate these Terms or if we
        believe your actions may cause legal liability for us or other users.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">5. Your Responsibilities</h3>
    <p>
      You agree to use our Services in a lawful manner and in accordance with
      these Terms. You agree not to:
    </p>

    <ul class="list-disc ps-5">
      <li>Use our Services for any illegal or unauthorized purpose.</li>
      <li>
        Violate any applicable laws, regulations, or third-party rights,
        including intellectual property rights.
      </li>
      <li>
        Interfere with or disrupt the integrity or performance of our Services.
      </li>
      <li>
        Attempt to gain unauthorized access to our Services or related systems
        or networks.
      </li>
      <li>Transmit any viruses, worms, or other malicious code.</li>
      <li>
        Engage in any activity that is harmful, fraudulent, deceptive, or
        otherwise objectionable.
      </li>
      <li>
        Impersonate any person or entity, or falsely state or otherwise
        misrepresent your affiliation with a person or entity.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">6. Intellectual Property</h3>
    <ul class="list-disc ps-5">
      <li>
        <strong>Our Content:</strong> All content on our Services, including
        text, graphics, logos, images, software, and the compilation thereof, is
        our property or the property of our licensors and is protected by
        Nigerian and international copyright, trademark, and other intellectual
        property laws.
      </li>
      <li>
        <strong>Your Content:</strong> You retain ownership of any content you
        submit, post, or display on or through our Services. By submitting,
        posting, or displaying content, you grant us a worldwide, non-exclusive,
        royalty-free, transferable, and sublicensable license to use, reproduce,
        modify, adapt, publish, translate, create derivative works from,
        distribute, and display such content in connection with the operation
        and promotion of our Services.
      </li>
      <li>
        <strong>Trademarks:</strong> Our trademarks, service marks, graphics,
        and logos used in connection with the Services are trademarks or
        registered trademarks of corpers.ng. Other trademarks, service marks,
        graphics, and logos used in connection with the Services may be the
        trademarks of their respective owners. You are granted no right or
        license with respect to any of the aforesaid trademarks and any use of
        such trademarks.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">7. Data Protection and Privacy</h3>
    <p>
      We are committed to protecting your personal data in accordance with the
      Nigeria Data Protection Act (NDPA) 2023 and the Nigeria Data Protection
      Regulation (NDPR) 2019. Our Privacy Policy explains how we collect, use,
      disclose, and protect your personal data. By using our Services, you
      consent to our data practices as described in our Privacy Policy.
    </p>

    <h3 class="pt-4 text-2xl">8. Consumer Protection</h3>
    <p>
      We are committed to providing fair and transparent services in compliance
      with the Federal Competition and Consumer Protection Act (FCCPA) 2018.
    </p>

    <!-- convert each line to a list item in an unordered list -->
    <ul class="list-disc ps-5">
      <li>
        <strong>Information Disclosure:</strong> We will provide clear,
        truthful, and accurate information about our products and services,
        including pricing and any applicable terms and conditions.
      </li>
      <li>
        <strong>Right to Redress:</strong> If you are dissatisfied with our
        Services or a product/service obtained through our platform, you have
        the right to seek redress in accordance with applicable consumer
        protection laws.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">9. Disclaimers and Limitation of Liability</h3>
    <ul class="list-disc ps-5">
      <li>
        <strong>Disclaimer of Warranties:</strong> OUR SERVICES ARE PROVIDED "AS
        IS" AND "AS AVAILABLE," WITHOUT ANY WARRANTIES OF ANY KIND, EXPRESS OR
        IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY,
        FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT
        WARRANT THAT OUR SERVICES WILL BE UNINTERRUPTED, ERROR-FREE, SECURE, OR
        FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
      </li>
      <li>
        <strong>Limitation of Liability:</strong> TO THE FULLEST EXTENT
        PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL [YOUR STARTUP NAME], ITS
        AFFILIATES, DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT,
        INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT
        NOT LIMITED TO LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE
        LOSSES, ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF OR INABILITY TO
        USE OUR SERVICES, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING
        NEGLIGENCE), OR ANY OTHER LEGAL THEORY, EVEN IF WE HAVE BEEN ADVISED OF
        THE POSSIBILITY OF SUCH DAMAGES.
      </li>
      <li>
        <strong>Maximum Liability:</strong> IN NO EVENT SHALL OUR TOTAL
        LIABILITY TO YOU FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION ARISING
        OUT OF OR RELATING TO THESE TERMS OR YOUR USE OF OUR SERVICES EXCEED THE
        AMOUNT PAID BY YOU, IF ANY, FOR ACCESSING OR USING OUR SERVICES DURING
        THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE DATE OF THE CLAIM.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">10. Indemnification</h3>
    <p>
      You agree to indemnify, defend, and hold harmless corpers.ng, its
      affiliates, directors, employees, and agents from and against any and all
      claims, liabilities, damages, losses, costs, and expenses (including
      reasonable attorneys' fees) arising out of or in connection with your use
      of our Services, your violation of these Terms, or your violation of any
      rights of another.
    </p>

    <h3 class="pt-4 text-2xl">11. Governing Law and Dispute Resolution</h3>
    <ul class="list-disc ps-5">
      <li>
        <strong>Governing Law:</strong> These Terms shall be governed by and
        construed in accordance with the laws of the Federal Republic of
        Nigeria, without regard to its conflict of law principles.
      </li>
      <li>
        <strong>Dispute Resolution:</strong> Any dispute, controversy, or claim
        arising out of or relating to these Terms or the breach, termination, or
        invalidity thereof, shall be settled by negotiation between the parties
        in good faith. If the parties are unable to resolve the dispute through
        negotiation within thirty (30) days, the dispute shall be submitted to
        mediation in Lagos, Nigeria, in accordance with the rules of the Lagos
        State Multi-Door Courthouse. If mediation is unsuccessful, the dispute
        shall be finally resolved by arbitration in Lagos, Nigeria, in
        accordance with the provisions of the Arbitration and Conciliation Act,
        Cap. A18, Laws of the Federation of Nigeria, 2004. The language of the
        arbitration shall be English. The decision of the arbitrator(s) shall be
        final and binding on both parties.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">12. Miscellaneous</h3>

    <ul class="list-disc ps-5">
      <li>
        <strong>Entire Agreement:</strong> These Terms, together with our
        Privacy Policy, constitute the entire agreement between you and
        corpers.ng regarding your use of our Services.
      </li>
      <li>
        <strong>Severability:</strong> If any provision of these Terms is found
        to be invalid or unenforceable, the remaining provisions shall remain in
        full force and effect.
      </li>
      <li>
        <strong>Waiver:</strong> No waiver of any provision of these Terms shall
        be deemed a further or continuing waiver of such provision or any other
        provision.
      </li>
      <li>
        <strong>Assignment:</strong> You may not assign or transfer these Terms
        or any of your rights or obligations hereunder without our prior written
        consent. We may assign or transfer these Terms and our rights and
        obligations hereunder at our sole discretion.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">13. Contact Information</h3>
    <p>If you have any questions about these Terms, please contact us at:</p>
    <p>
      corpers.ng
      <br />
      Email: info&#64;corpers.ng
      <br />
      corpers.ng is a company duly registered under the laws of the Federal
      Republic of Nigeria.
    </p>
  </section>

  <section class="mt-2 md:mt-10 px-7 md:px-16" id="privacy-policy">
    <h2 class="pt-4 text-4xl">Privacy Policy for corpers.ng</h2>

    <h3 class="py-4 text-xl">Effective Date: June 4, 2025</h3>

    <p>
      This Privacy Policy describes how [Your Startup Name] ("we," "our," or
      "us") collects, uses, discloses, and protects your personal data when you
      use our website, mobile application, and any related services
      (collectively, the "Services").
    </p>

    <p>
      We are committed to protecting your privacy and handling your personal
      data in compliance with the Nigeria Data Protection Act (NDPA) 2023 and
      the Nigeria Data Protection Regulation (NDPR) 2019.
    </p>

    <p>
      By accessing or using our Services, you agree to the collection, use,
      disclosure, and protection of your personal data as described in this
      Privacy Policy. If you do not agree with the terms of this Privacy Policy,
      please do not use our Services.
    </p>
    <h3 class="pt-4 text-2xl">1. Definitions</h3>

    <ul class="list-disc ps-5">
      <li>
        <strong>Personal Data:</strong> Any information relating to an
        identified or identifiable natural person (data subject). This includes,
        but is not limited to, names, contact details, identification numbers,
        location data, online identifiers, and other factors specific to the
        physical, physiological, genetic, mental, economic, cultural, or social
        identity of that person.
      </li>
      <li>
        <strong>Processing:</strong> Any operation or set of operations
        performed on personal data, whether or not by automated means, such as
        collection, recording, organization, structuring, storage, adaptation,
        alteration, retrieval, consultation, use, disclosure by transmission,
        dissemination, or otherwise making available, alignment or combination,
        restriction, erasure, or destruction.
      </li>
      <li>
        <strong>Data Controller:</strong> The natural or legal person, public
        authority, agency, or other body which, alone or jointly with others,
        determines the purposes and means of the processing of personal data.
        For the purpose of this Privacy Policy, we are the Data Controller of
        your Personal Data.
      </li>

      <li>
        <strong>Data Subject:</strong> The identified or identifiable natural
        person to whom Personal Data relates. This is you, our user.
      </li>

      <li>
        <strong>Third Party:</strong> A natural or legal person, public
        authority, agency, or body other than the data subject, controller,
        processor, and persons who, under the direct authority of the controller
        or processor, are authorized to process personal data.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">2. Personal Data We Collect</h3>
    <p>
      We may collect various types of personal data from you, depending on how
      you interact with our Services:
    </p>
    <h4>a. Information You Provide Directly to Us:</h4>

    <ul class="list-disc ps-5">
      <li>
        <strong>Contact Information:</strong> Name, email address, phone number,
        and physical address.
      </li>
      <li>
        <strong>Account Information:</strong> Username, password, profile
        picture.
      </li>
      <li>
        <strong>Identity Information:</strong> Date of birth, gender,
        nationality, national identification number (e.g., NIN, BVN, Voters
        Card) if required for specific services (e.g., financial transactions,
        KYC verification).
      </li>

      <li>
        <strong>Financial Information:</strong> Bank account details, payment
        card information (though typically processed by third-party payment
        processors, we may receive limited information for transaction
        verification).
      </li>
      <li>
        <strong>Communications:</strong> Any information you provide when you
        communicate with us, such as customer support inquiries, feedback, or
        survey responses.
      </li>
      <li>
        <strong>User-Generated Content:</strong> Any content you upload, post,
        or transmit through our Services (e.g., reviews, comments, photos).
      </li>
    </ul>

    <h4>b. Information We Collect Automatically:</h4>

    <ul class="list-disc ps-5">
      <li>
        <strong>Usage Data:</strong> Information about how you access and use
        our Services, including your IP address, device type, operating system,
        browser type, pages visited, time spent on pages, referral source, and
        clicks.
      </li>
      <li>
        <strong>Location Data:</strong> Depending on your device settings, we
        may collect precise or approximate location information (e.g., GPS,
        Wi-Fi, cell tower data) to provide location-based services.
      </li>
      <li>
        <strong>Cookies and Similar Technologies:</strong> We use cookies, web
        beacons, and similar tracking technologies to collect information about
        your Browse activities, preferences, and interactions with our Services.
        For more details, please refer to our Cookie Policy (if applicable, or
        expand on this section).
      </li>
    </ul>

    <h4>c. Information from Third Parties:</h4>

    <p>
      We may receive information about you from third-party services, such as
      social media platforms (if you choose to link your accounts), identity
      verification services, or marketing partners, in accordance with their
      privacy policies.
    </p>
    <h3 class="pt-4 text-2xl">3. How We Use Your Personal Data</h3>
    <p>
      We use your personal data for various purposes based on legal grounds,
      including:
    </p>

    <h4>a. To Provide and Maintain Our Services:</h4>

    <ul class="list-disc ps-5">
      <li>To create and manage your account.</li>
      <li>To process your transactions and orders.</li>
      <li>To provide customer support and respond to your inquiries.</li>
      <li>To deliver the features and functionalities of our Services.</li>
      <li>To monitor the performance and stability of our Services.</li>
    </ul>
    <h4>b. To Improve and Personalize Our Services:</h4>

    <ul class="list-disc ps-5">
      <li>To analyze usage trends and optimize our Services.</li>
      <li>To develop new products, features, and functionalities.</li>
      <li>
        To personalize your experience and recommend relevant content or
        services.
      </li>
      <li>To conduct research and analytics.</li>
    </ul>
    <h4>c. For Communication:</h4>

    <ul class="list-disc ps-5">
      <li>
        To send you important notices, updates, and administrative messages.
      </li>
      <li>
        To send you marketing and promotional communications about our Services
        or those of our partners (where you have given consent or where
        permitted by law). You can opt-out of marketing communications at any
        time.
      </li>
    </ul>

    <h4>d. For Security and Fraud Prevention:</h4>

    <ul class="list-disc ps-5">
      <li>
        To detect, prevent, and investigate fraudulent or unauthorized
        activities.
      </li>
      <li>
        To protect the security and integrity of our Services and our users.
      </li>
    </ul>

    <h4>e. For Legal and Compliance Purposes:</h4>

    <ul class="list-disc ps-5">
      <li>
        To comply with applicable laws, regulations, and legal processes (e.g.,
        tax, anti-money laundering, consumer protection).
      </li>
      <li>To enforce our Terms of Service and other agreements.</li>
      <li>
        To protect our rights, privacy, safety, or property, and/or that of our
        affiliates, you, or others.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">
      4. Legal Basis for Processing Your Personal Data
    </h3>

    <p>
      We process your personal data based on the following legal grounds, as
      permitted by the NDPA:
    </p>

    <ul class="list-disc ps-5">
      <li>
        <strong>Consent:</strong> Where you have given explicit consent for us
        to process your personal data for one or more specific purposes.
      </li>
      <li>
        <strong>Contractual Necessity:</strong> Where the processing is
        necessary for the performance of a contract to which you are a party or
        in order to take steps at your request prior to entering into a
        contract.
      </li>
      <li>
        <strong>Legal Obligation:</strong> Where the processing is necessary for
        compliance with a legal obligation to which we are subject.
      </li>
      <li>
        <strong>Legitimate Interests:</strong> Where the processing is necessary
        for the purposes of the legitimate interests pursued by us or by a third
        party, except where such interests are overridden by your interests or
        fundamental rights and freedoms. Examples include improving our
        services, preventing fraud, and direct marketing (with opt-out options).
      </li>
      <li>
        <strong>Public Interest:</strong> Where the processing is necessary for
        the performance of a task carried out in the public interest.
      </li>
      <li>
        <strong>Vital Interests:</strong> Where the processing is necessary in
        order to protect your vital interests or those of another natural
        person.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">5. Disclosure of Your Personal Data</h3>
    <p>
      We may disclose your personal data to the following categories of
      recipients:
    </p>

    <ul class="list-disc ps-5">
      <li>
        <strong>Service Providers:</strong> Third-party vendors and service
        providers who perform services on our behalf, such as payment
        processing, hosting, analytics, customer support, marketing, and IT
        services. These service providers are obligated to protect your data and
        only use it for the purposes for which it was provided.
      </li>
      <li>
        <strong>Business Partners:</strong> With your consent, we may share your
        information with business partners for joint promotions or services.
      </li>
      <li>
        <strong>Affiliates:</strong> To our parent company, subsidiaries, and
        other affiliates for business and operational purposes.
      </li>
      <li>
        <strong>Legal and Regulatory Authorities:</strong> When required by law,
        court order, or governmental regulation, or when we believe in good
        faith that disclosure is necessary to protect our rights, property, or
        safety, or the rights, property, or safety of others.
      </li>
      <li>
        <strong>Successors in Interest:</strong> In connection with a merger,
        acquisition, sale of assets, or other corporate restructuring, your
        personal data may be transferred to the acquiring entity.
      </li>
      <li>
        <strong>Other Users:</strong> Certain information, such as your username
        or profile picture, may be visible to other users of our Services,
        depending on your privacy settings and the nature of the service.
      </li>
      <li>
        <strong>With Your Consent:</strong> We may share your information with
        other third parties when you have given your explicit consent to do so.
      </li>
    </ul>

    <h3 class="pt-4 text-2xl">6. International Data Transfers</h3>

    <p>
      Your personal data may be transferred to, stored, and processed in
      countries outside of Nigeria, where data protection laws may differ. When
      we transfer your personal data internationally, we will take appropriate
      safeguards to ensure your data is protected in accordance with the NDPA
      and NDPR, such as implementing Standard Contractual Clauses or ensuring
      the recipient country has an adequate level of data protection.
    </p>

    <h3 class="pt-4 text-2xl">7. Data Security</h3>
    <p>
      We implement reasonable technical and organizational measures to protect
      your personal data from unauthorized access, use, disclosure, alteration,
      or destruction. These measures include:
    </p>

    <ul class="list-disc ps-5">
      <li>
        <strong>Encryption:</strong> Using encryption for data in transit and at
        rest where appropriate.
      </li>
      <li>
        <strong>Access Controls:</strong> Restricting access to personal data to
        authorized personnel only.
      </li>
      <li>
        <strong>Regular Security Audits:</strong> Conducting regular security
        assessments and vulnerability scans.
      </li>
      <li>
        <strong>Employee Training:</strong> Training our employees on data
        protection best practices.
      </li>
    </ul>
    <p>
      However, please be aware that no method of transmission over the internet
      or method of electronic storage is 100% secure. While we strive to protect
      your personal data, we cannot guarantee its absolute security.
    </p>

    <h3 class="pt-4 text-2xl">8. Data Retention</h3>
    <p>
      We retain your personal data for as long as necessary to fulfill the
      purposes for which it was collected, including for the purposes of
      satisfying any legal, accounting, or reporting requirements.
    </p>

    <p>
      To determine the appropriate retention period for personal data, we
      consider the amount, nature, and sensitivity of the personal data, the
      potential risk of harm from unauthorized use or disclosure of your
      personal data, the purposes for which we process your personal data and
      whether we can achieve those purposes through other means, and the
      applicable legal requirements.
    </p>

    <h3 class="pt-4 text-2xl">9. Your Data Protection Rights</h3>

    <p>
      Under the NDPA, you have the following rights regarding your personal
      data:
    </p>

    <ul class="list-disc ps-5">
      <li>
        Right to Be Informed: The right to be informed about the collection and
        use of your personal data.
      </li>
      <li>
        Right of Access: The right to request access to the personal data we
        hold about you.
      </li>
      <li>
        Right to Rectification: The right to request that we correct any
        inaccurate or incomplete personal data we hold about you.
      </li>
      <li>
        Right to Erasure (Right to Be Forgotten): The right to request the
        deletion or removal of your personal data where there is no compelling
        reason for its continued processing.
      </li>
      <li>
        Right to Restrict Processing: The right to request that we restrict the
        processing of your personal data under certain conditions.
      </li>
      <li>
        Right to Data Portability: The right to receive your personal data in a
        structured, commonly used, and machine-readable format and to transmit
        that data to another controller without hindrance.
      </li>
      <li>
        Right to Object: The right to object to the processing of your personal
        data for direct marketing purposes or on grounds relating to your
        particular situation.
      </li>
      <li>
        Rights in Relation to Automated Decision-Making and Profiling: The right
        not to be subject to a decision based solely on automated processing,
        including profiling, which produces legal effects concerning you or
        similarly significantly affects you.
      </li>
      <li>
        Right to Lodge a Complaint: The right to lodge a complaint with the
        National Data Protection Commission (NDPC) if you believe your data
        protection rights have been violated.
      </li>
    </ul>

    <p>
      To exercise any of these rights, please contact us using the contact
      details provided in Section 11 below. We will respond to your request in
      accordance with applicable data protection laws. We may need to verify
      your identity before fulfilling your request.
    </p>
    <h3 class="pt-4 text-2xl">10. Children's Privacy</h3>
    <p>
      Our Services are not intended for children under the age of 18. We do not
      knowingly collect personal data from children under 18. If you are a
      parent or guardian and believe that your child has provided us with
      personal data, please contact us, and we will take steps to remove such
      information from our records.
    </p>
    <h3 class="pt-4 text-2xl">11. Changes to This Privacy Policy</h3>
    <p>
      We may update this Privacy Policy from time to time to reflect changes in
      our practices, legal requirements, or new technologies. We will notify you
      of any material changes by posting the updated Privacy Policy on our
      website or through other reasonable means. Your continued use of the
      Services after the effective date of the revised Privacy Policy
      constitutes your acceptance of the changes.
    </p>
    <h3 class="pt-4 text-2xl">12. Contact Us</h3>
    <p>
      If you have any questions or concerns about this Privacy Policy or our
      data practices, please contact us at:
    </p>

    <p>
      corpers.ng
      <br />
      Nigeria
      <br />
      Email: info&#64;corpers.ng
    </p>
  </section>

  <footer class="p-5 md:p-10 text-center text-gray-400 text-sm">
    Say hi info&#64;corpers.ng // &copy; 2025 corpers.ng // All rights reserved.
  </footer>
</body>
